import { preloadToothChartAssets } from '@components/pages/Charting/Dental/tooth-chart-preload.utils'
import type { ChartingRouteTab } from './chartingNoteOverlay.util'

/**
 * Preload assets needed before showing a charting tab after a tab switch.
 */
export async function preloadChartingTabAssets(
  tab: ChartingRouteTab,
): Promise<void> {
  switch (tab) {
    case 'home':
    case 'treatment-plan':
      await preloadToothChartAssets('full')
      break
    case 'perio':
    case 'history':
      // No tooth SVGs; yield so the next route can mount and measure layout.
      await new Promise<void>((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => resolve())
        })
      })
      break
    default:
      break
  }
}
